export default __webpack_public_path__ + "static/media/myself.90288f0a.jpeg";